<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<div class="bannerCont">
					<p class="p1">关于我们<span>/ABOUT US</span></p>
					<p class="p2">品质打造品牌，服务提高荣誉</p>
				</div>
			</div>
			<!-- 位置 -->
			<div class="public site">
				<span class="square"></span>
				<p>您的位置： 首页  <span>></span>   好停车简介</p>
			</div>
			<!-- 简介/荣誉 -->
			<div class="public title">
				<ul>
					<li v-for="(tab,index) in tabs" @click="toggle(index,tab.view)" :class="{active:active==index}" :key="index">
						{{tab.type}}
						<div :class="{sangle:active==index}"></div>
					</li>
				</ul>
				<!--:is实现多个组件实现同一个挂载点-->
				<component :is="currentView"></component>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	import tab1 from '@/components/tab1.vue'
	import tab2 from '@/components/tab2.vue'
	export default{
		data(){
			return{
				active:0,
				currentView:'tab1',
				tabs:[
					{
					  type:'公司简介',
					  view:'tab1'
					},
					{
					  type:'荣誉资质',
					  view:'tab2'
					}
				]
			}
		},
		methods:{
		    toggle(i,v){
				this.active=i;
				this.currentView=v;
		    }
		},
		components:{
			headers,footers,
			tab1,
			tab2
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.banner{
		width: 100%;
		height:540px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/abouT.png) center no-repeat;
		background-size:100%;
		text-align: center;
		.bannerCont{
			width: 1200px;
			height: 380px;
			padding-top: 200px;
			color: #fff;
			margin: 0 auto;
			text-align:left;
			.p1{
				font-size: 40px;
				padding: 10px;
				font-weight: bold;
				span{
					font-size: 24px;
					padding-left: 10px;
					letter-spacing: 5px;
				}
			}
			.p2{
				font-size:32px;
				padding: 10px;
				width: 481px;
				letter-spacing: 5px;
				font-weight: bold;
				background: rgba(74,134,255,0.5);
			}
		}
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.site{
		height: 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: left;
		font-size:16px;
		color:#333;
		margin: 30px auto;
		border-bottom:1px dashed #ccc;
		.square{
			display: inline-block;
			width: 10px;
			height: 20px;
			background: #000;
			margin-right: 10px;
		}
		p{
			span{
				padding: 0 5px;
			}
		}
	}
	.title{
		ul{
			width:1200px;
			display:flex;
		}
		ul li{
			width:600px;
			height:56px;
			background: #f4f4f4;
			display: inline-flex;
			justify-content: center;
			align-items: center;
			cursor:pointer;
			position: relative;
		}
		ul li.active{
			background:#3c77f0;
			color: #fff;
		}
		.sangle{
			width:0; 
			height:0; 
			border-left:10px solid transparent;
			border-right:10px solid transparent;
			border-bottom:10px solid #fff;
			border-top:0px;
			position: absolute;
			bottom: 0;
			left: 50%;
			margin-left: -5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue